import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { findNavLabel } from "../app/navigation";
import "./AccessDenied.css";

/**
 * «Нет доступа» (403): раздел существует, но роли пользователя он не положен.
 *
 * Раньше гард молча перекидывал на стартовую страницу роли — пользователь не понимал, почему
 * ссылка «не открывается». Теперь говорим прямо, какой раздел закрыт и к кому идти.
 */
export default function AccessDenied({ homeTo = "/" }) {
  const location = useLocation();
  const navigate = useNavigate();
  const section = findNavLabel(location.pathname);

  return (
    <div className="access-denied" role="alert">
      <div className="ad-box">
        <div className="ad-code">403</div>
        <div className="ad-title">Нет доступа</div>
        <div className="ad-text">
          {section ? (
            <>
              У вашей роли нет доступа к разделу <span className="ad-section">«{section}»</span>.
            </>
          ) : (
            "У вашей роли нет доступа к этой странице."
          )}{" "}
          Если он нужен для работы, попросите директора добавить право в «Управление → Роли и права».
        </div>
        <div className="ad-actions">
          <button type="button" className="ad-btn ad-btn--primary" onClick={() => navigate(homeTo)}>
            На мою страницу
          </button>
          <button type="button" className="ad-btn" onClick={() => navigate(-1)}>
            Назад
          </button>
        </div>
      </div>
    </div>
  );
}
